import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

type AdminChartSaveDialogProps = {
  isOpen: boolean;
  toggle: () => void;
  onSave: (value: "chart" | "full-deck") => void;
};

const AdminChartSaveDialog = ({
  isOpen,
  toggle,
  onSave,
}: AdminChartSaveDialogProps) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog open={isOpen} onClose={() => toggle()} className="relative z-50">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        </Transition.Child>
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="mx-auto w-96 h-96 max-w-sm rounded bg-white p-8">
              <Dialog.Title className="text-primary-blue text-2xl uppercase text-center">
                What would you like to do next?
              </Dialog.Title>
              <p className="text-center my-8">
                Would you like to only create a chart OR create a full test
                deck?
              </p>
              <div className="flex justify-center my-4">
                <button
                  onClick={() => {
                    onSave("chart");
                  }}
                  className="w-full inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                >
                  CREATE CHART
                </button>
              </div>
              <div className="flex justify-center">
                <button
                  onClick={() => {
                    onSave("full-deck");
                  }}
                  className="w-full inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                >
                  CREATE FULL TEST DECK
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AdminChartSaveDialog;
